const PEER_CONFIG = {
  host: process.env.VUE_APP_SIGNALING_HOST,
  port: process.env.VUE_APP_SIGNALING_PORT,
  secure: process.env.NODE_ENV !== 'development',
  iceServers: [
    { 'urls': 'stun:54.249.247.167:80' },
    { 'urls': 'turn:54.249.247.167:80?transport=tcp', 'username': 'ice-smart-crm','credential': 'nL&I~Cy[8}O-WQ%2' }
  ]
}

export default PEER_CONFIG
